import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import { useUserTasks, useMyGames, useEditGameTask } from "@seabrookstudios/pitch2table";
import { Path } from "../Path";
import Checkbox from "@mui/material/Checkbox";
import ListItemIcon from "@mui/material/ListItemIcon";
import { CircularProgressSize } from "../theme";
import CircularProgress from "@mui/material/CircularProgress";
import { ArrowListItem } from "../core/ArrowListItem";

/**
 * Task list entry component
 * @param {Object} props
 * @param {import("@seabrookstudios/pitch2table-core").UserTask} props.item - Task item from useUserTasks
 */
const TaskListEntry = ({ item }) => {
  const { data: games = [] } = useMyGames();

  const editTask = useEditGameTask(item.gameId, item.taskId);

  const game = games.find((g) => g.id === item.gameId);

  const handleToggleComplete = async () => {
    await editTask.mutateAsync({
      name: undefined,
      order: undefined,
      status: "Done",
    });
  };

  if (!game) {
    return null;
  }

  const Left = () => (
    <ListItemIcon>
      {editTask.isPending ? (
        <CircularProgress size={CircularProgressSize} />
      ) : (
        <Checkbox checked={false} onChange={handleToggleComplete} />
      )}
    </ListItemIcon>
  );

  return <ArrowListItem Left={Left} primary={game.name} secondary={item.task} to={Path.game(item.gameId).tasks()} />;
};

export const TasksCard = () => {
  const { data: tasks = [], isLoading } = useUserTasks();

  if (isLoading || tasks.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader title="What to do next?" />
      <CardContent>
        <List dense>
          {tasks.map((task) => (
            <TaskListEntry item={task} key={task.gameId} />
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
